<template>
  <transition v-if="this.currentStep >= 3" name="fade">
    <div class="panel panel-primary">
      <div @click="show = !show" class="panel-heading">
        3 - RESULTADO SIMULAÇÃO<span class="pull-right">
          <i
            style="font-size: 1.5em"
            :class="show ? 'fa fa-arrow-down' : 'fa fa-arrow-right'"
            aria-hidden="true"
          ></i>
        </span>
      </div>
      <div v-if="show" class="panel-body">
        <div>
          <div class="content">
            <table class="table table-striped">
              <tbody>
                <tr>
                  <th scope="row">Valor Entrada</th>
                  <td class="text-right">
                    {{ 0 | reais }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Valor Líquido Liberado</th>
                  <td class="text-right">
                    {{ this.resultadoSimulacao.ValorSolicitado | reais }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Valor IOF</th>
                  <td class="text-right">
                    {{ this.resultadoSimulacao.VlrIOF | reais }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Parcelas</th>
                  <td class="text-right">
                    {{ this.resultadoSimulacao.Prazo }}
                    vezes de
                    {{ this.resultadoSimulacao.VlrParcela | reais }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Percentual Juros Mensais </th>
                  <td class="text-right">
                    {{ this.resultadoSimulacao.PercJurosMensal.toFixed(2).replace(".", ",") }}%
                  </td>
                </tr>
                <tr>
                  <th scope="row">Percentual Juros Anuais </th>
                  <td class="text-right">
                    {{ this.resultadoSimulacao.PercJurosAnual.toFixed(2).replace(".", ",") }}%
                  </td>
                </tr>
                <tr>
                  <th scope="row">Percentual CET Mensal</th>
                  <td class="text-right">
                    {{ this.resultadoSimulacao.PercCETMensal.toFixed(2).replace(".", ",") }}%
                  </td>
                </tr>
                <tr>
                  <th scope="row">Percentual CET Anual</th>
                  <td class="text-right">
                    {{ this.resultadoSimulacao.PercCETAnual.toFixed(2).replace(".", ",") }}%
                  </td>
                </tr>
                <tr>
                  <th scope="row">Valor Total Financiado</th>
                  <td class="text-right">
                    {{ this.resultadoSimulacao.VlrTotalCredito | reais }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Valor Total Pago Final</th>
                  <td class="text-right">
                    {{ this.resultadoSimulacao.VlrTotalDivida | reais }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <button
            v-if="currentStep == 3"
            aria-label="Anterior"
            style="float: left; margin-right: 1em"
            class="btn btn-primary"
            @click="previousStep()"
          >
            <i class="fa fa-chevron-left"></i> Anterior
          </button>

          <button
            v-if="currentStep == 3"
            aria-label="Próximo"
            style="float: left; margin-right: 1em"
            class="btn btn-primary"
            @click="nextStep()"
          >
            Próximo <i class="fa fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "SolAgoraStep3",
  props: {
    resultadoSimulacao: { type: Object, default: null },
    currentStep: { type: Number, default: 0 },
  },
  data() {
    return {
      show: true,
    };
  },
  methods: {
    previousStep: function () {
      this.$emit("previous");
    },

    nextStep: function () {
      this.$emit("next");
    },
  },
};
</script>